import React from "react";
import styles from "../../screens/variables/views/list_view.module.css";
import {useTranslation} from "react-i18next";

function HighAlert({disabled, value, maxTolerated, minTolerated, isBoolean}) {
    const {t} = useTranslation();
    // Determinar si es High (por encima) o Low (por debajo)
    // Para booleanos, mostrar "NOK" en lugar de "High"/"Low"
    const getLabel = () => {
        if (isBoolean) {
            return t('alerts.nok');
        }
        if (value === undefined || (maxTolerated === undefined && minTolerated === undefined)) {
            return t('alerts.high');
        }
        const val = parseFloat(value);
        const max = parseFloat(maxTolerated) || 0;
        const min = parseFloat(minTolerated) || 0;

        if (val > max) return t('alerts.high');
        if (val < min) return t('alerts.low');
        return t('alerts.high');
    }

    return (
        <div className={`${styles.variable_severity_container}`} style={disabled ? {color: "#64748B", backgroundColor: "#F1F5F9"} : {backgroundColor: "#FFE2E5"}}>
            <img src={`/alerts/high${disabled ? '_disabled' : ''}.png`} alt={'high'} height={'24px'}/>
            <div className={styles.variable_severity_text}>{getLabel()}</div>
        </div>
    )
}

function MediumAlert({disabled, value, maxDesired, minDesired, isBoolean}) {
    const {t} = useTranslation();
    // Determinar si es Slightly High (por encima) o Slightly Low (por debajo)
    // Para booleanos, mostrar "NOK" en lugar de "Slightly High"/"Slightly Low"
    const getLabel = () => {
        if (isBoolean) {
            return t('alerts.nok');
        }
        if (value === undefined || (maxDesired === undefined && minDesired === undefined)) {
            return t('alerts.medium');
        }
        const val = parseFloat(value);
        const max = parseFloat(maxDesired) || 0;
        const min = parseFloat(minDesired) || 0;

        if (val > max) return t('alerts.slightlyHigh');
        if (val < min) return t('alerts.slightlyLow');
        return t('alerts.medium');
    }

    return(
        <div className={`${styles.variable_severity_container}`} style={disabled ? {color: "#64748B", backgroundColor: "#F1F5F9"} : {backgroundColor: "#FFF4DE"}}>
            <img src={`/alerts/medium${disabled ? '_disabled' : ''}.png`} alt={'medium'} height={'24px'}/>
            <div className={styles.variable_severity_text}>{getLabel()}</div>
        </div>
    );
}

function LowAlert({disabled}) {
    const {t} = useTranslation();
    return (
        <div className={styles.variable_severity_container} style={disabled ? {color: "#64748B", backgroundColor: "#F1F5F9"} : {backgroundColor: "#DCFCE7"}}>
            <img src={`/alerts/low${disabled ? '_disabled' : ''}.png`} alt={'low'} height={'24px'}/>
            <div className={styles.variable_severity_text}>{t('alerts.ok')}</div>
        </div>
    );
}

export {
    HighAlert,
    MediumAlert,
    LowAlert
}